import { Space, Typography } from "antd";
import React, { Component } from "react";

class BusinessData extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const tableStyles = {
      width: "100%",
    };
    const rowStyles = {
      border: "1px solid #d9d9d9",
      padding: "8px 0px",
      textAlign: "left",
      paddingLeft: "8px",
      width: "50%",
    };
    return (
      <div
        style={{
          width: this.props.userData.isMobile ? "100%" : "80%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "start",
            width: "100%",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography.Title
              level={5}
              style={{
                margin: "10px 0px",
              }}
            >
              Datos de la sociedad
            </Typography.Title>
          </div>
          <table style={tableStyles}>
            <tbody>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Razón social:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.businessName}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>NIF:</Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{this.props.userData.customer.nif}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Dirección:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.street}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Localidad:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.locality}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Código Postal:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.postalCode}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Provincia:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.province}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Teléfono:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.mobile}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>Email:</Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.email}`}</Typography>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            width: "100%",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography.Title
              level={5}
              style={{
                margin: "10px 0px",
              }}
            >
              Datos del apoderado
            </Typography.Title>
          </div>
          <table style={tableStyles}>
            <tbody>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Nombre:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.manager.name}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Apellido:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>{`${this.props.userData.customer.manager.lastName} ${this.props.userData.customer.manager.lastName2}`}</Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>
                    DNI / NIF / NIE:
                  </Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>
                    {this.props.userData.customer.manager.dni}
                  </Typography>
                </td>
              </tr>
              <tr>
                <td style={rowStyles}>
                  <Typography style={{ fontWeight: "bold" }}>Cargo:</Typography>
                </td>
                <td style={rowStyles}>
                  <Typography>Apoderado/a</Typography>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default BusinessData;



// WEBPACK FOOTER //
// ./src/views/Contract/components/BusinessData.jsx